/**
 * Native HTML5 drag payload for workspace files dragged out of chrome that
 * lives OUTSIDE the app-wide dnd-kit provider (e.g. the docked Add-from-
 * add-mode dialog). The data is the file record id; the canvas board's native
 * drop path resolves it into a reference at the cursor. dnd-kit drags never
 * populate dataTransfer, so the two channels can't collide.
 */
export const WORKSPACE_FILE_DRAG_MIME = "application/x-cohesive-library-file";

/**
 * Companion payload for workspace FOLDER drags from the same chrome. The data
 * is JSON: `{ workspaceId, path, name }` — the canvas drop resolves the
 * folder's descendant files and lands them as a section of references.
 */
export const WORKSPACE_FOLDER_DRAG_MIME =
  "application/x-cohesive-library-folder";

export interface WorkspaceFolderDragPayload {
  workspaceId: string;
  path: string;
  name: string;
}
